import { createContext, useCallback, useContext, useState, ReactNode } from 'react';
import { AlertModal } from '../components/Modal';

interface AlertButton {
  text: string;
  onPress?: () => void;
  style?: 'default' | 'cancel' | 'destructive';
}

interface AlertState {
  title: string;
  message?: string;
  buttons?: AlertButton[];
}

interface AlertCtxValue {
  alert: (title: string, message?: string, buttons?: AlertButton[]) => void;
}

const AlertCtx = createContext<AlertCtxValue>({ alert: () => {} });

export function AlertProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<AlertState | null>(null);

  const alert = useCallback((title: string, message?: string, buttons?: AlertButton[]) => {
    setState({ title, message, buttons });
  }, []);

  return (
    <AlertCtx.Provider value={{ alert }}>
      {children}
      <AlertModal
        open={!!state}
        onClose={() => setState(null)}
        title={state?.title || ''}
        message={state?.message}
        buttons={state?.buttons}
      />
    </AlertCtx.Provider>
  );
}

export const useAlert = () => useContext(AlertCtx);
